import qwest from 'qwest';
import session from '../services/sessionService.jsx';

import Analysis from '../models/analysis.jsx';

let onSuccess = type => {
  if (type === 'list') {
    return (xhr, response) => {
      if (response.success) {
        return response.data.map(x => Analysis.fromApiFormat(x));
      }
      throw response;
    };
  }
  if (type === 'single') {
    return (xhr, response) => {
      if (response.success) {
        return Analysis.fromApiFormat(response.data);
      }
      throw response;
    };
  }

  return (xhr, response) => {
    if (response.success) {
      return response.data;
    }
    throw response;
  };
};

let onError = () => {
  throw {
    code: -1,
    data: null,
    message: 'Unexpected Error',
    success: false,
  };
};

let analysisApi = {
  getAnalysis(id) {
    return qwest.get(`/Analysis?id=${id}`)
      .then(onSuccess('single'), onError);
  },

  getSourceWater(poolID) {
    return qwest.get(`/Analysis/Source?poolID=${poolID}`)
      .then(onSuccess('single'), onError);
  },

  getLatest(poolID) {
    return qwest.get(`/Analysis/Latest?poolID=${poolID}`)
      .then(onSuccess(), onError);
  },
  getCustomerLatest(customerID) {
    return qwest.get(`/Analysis/CustomerLatest?customerID=${customerID}`)
      .then((xhr, response) => {
        if (response.success && response.data !== null && response.data.ID !== null) {
          return Analysis.fromApiFormat(response.data);
        } else if (response.success) {
          return null;
        } else {
          throw response;
        }
      }, onError);
  },
  getRecent(poolID, analysisID) {
    return qwest.get(`/Analysis/Recent?poolID=${poolID}&analysisID=${analysisID}`)
      .then(onSuccess('list'), onError);
  },

  getAnalyses(poolID, start, end) {
    return qwest.get(`/Analysis/History?poolID=${poolID}&start=${start}&end=${end}`)
      .then(onSuccess('list'), onError);
  },

  getAnalysisPurchases(analysisIDArray) {
    return qwest.get(`/Analysis/PurchasesForAnalysis?analysisList=${analysisIDArray}`)
      .then(onSuccess(), onError);
  },

  deleteAnalysis(analysis) {
    return qwest.delete('/Analysis', analysis.toApiFormat())
      .then(onSuccess('single'), onError);
  },

  saveAnalysis(analysis) {
    return new Promise((resolve, reject) => {
      qwest.post('/Analysis', analysis.toApiFormat())
        .then((xhr, response) => {
          if (response.success) {
            let pool = session.getPool(analysis.poolID);

            if (pool) {
              session.deletePool(pool);
            }
            let am = Analysis.fromApiFormat(response.data);

            resolve(am);
          } else {
            reject(response);
          }
        });
    });
  },

  customerSummary(customerID) {
    return qwest.get(`/analysis/customer-summary/${customerID}`)
      .then((xhr, res) => res.data);
  },
};

export default analysisApi;
